import "./App.css";
import { Route, Routes } from "react-router-dom";
import { Step } from "./pages/Step/Step";
import { Articles } from "./pages/Articles/Articles";
import { Layout } from "./components/Layout";
import { IdeaBlock } from "./pages/Feedback/IdeaBlock";
import { useUser } from "./hooks/useUser";

function App() {
  useUser();

  return (
    <>
      <Routes>
        <Route
          index
          element={
            <Layout>
              <Articles />
            </Layout>
          }
        />
        <Route
          path="/:article_id"
          element={
            <Layout>
              <Step />
            </Layout>
          }
        />
        <Route
          path="/:article_id/:step_id"
          element={
            <Layout>
              <Step />
            </Layout>
          }
        />
        {/* <Route
          path="/:article_id"
          element={
            <Layout>
              <Step />
            </Layout>
          }
        /> */}
        {/* <Route
          path="/:company_id/idea"
          element={
            <Layout>
              <IdeaBlock />
            </Layout>
          }
        /> */}
      </Routes>
    </>
  );
}

export default App;
